import * as React from 'react';
import Box from '@mui/material/Box';

const Loader = ({ renderSkeleton }: any) => {
  return (
    <Box>
      {renderSkeleton}
    </Box >
  )
}
export default Loader;